// src/CalendarIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CalendarIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M8 2v4" }),
      /* @__PURE__ */ jsx("path", { d: "M16 2v4" }),
      /* @__PURE__ */ jsx("rect", { width: "18", height: "18", x: "3", y: "4", rx: "2" }),
      /* @__PURE__ */ jsx("path", { d: "M3 10h18" })
    ]
  }
);
var CalendarIcon_default = CalendarIcon;

export {
  CalendarIcon_default
};
